<template>
	<div class="sidebar-wrapper" :class="{ disabled: getLoading }">
		<div :class="['calc-sidebar sticky-box', getMobileMenu ? 'DropUp' : '']" ref="menu">
			<div class="calc-sidebar-box" ref="menu">
				<span class="mobile-close" @click="mobileMenu()"></span>
				<transition name="slide-fade">
					<div v-if="!porpertyElemets && !packageElemets">
						<span class="edit" @click="porpertyedit()"></span>
						<CalcElements :elements="contractDetails" />
						<a href="javascript:void(0);" class="sidebar-btn btn-blue-inverse" @click="packageEdit()">
							Kiegészítők módosítása
						</a>
					</div>
				</transition>

				<transition name="slide-fade">
					<div v-if="porpertyElemets && !packageElemets">
						<CalcElements :elements="computedPropertyDetails" class="porpertyElemets" />

						<a href="javascript:void(0);" class="btn-save btn-blue" @click="handlePropertyDetailsSave">
							Mentés
						</a>
						<a href="javascript:void(0);" @click="cancel()" class="cancel">mégse</a>
					</div>
				</transition>

				<transition name="slide-fade">
					<div v-if="packageElemets && !porpertyElemets">
						<CalcElements :elements="computedPackageInformations" class="packageElemets" />

						<a href="javascript:void(0);" class="btn-save btn-blue" @click="handleInsuranceEventsSave">
							Mentés
						</a>
						<a href="javascript:void(0);" @click="cancel()" class="cancel">mégse</a>
					</div>
				</transition>
			</div>
		</div>
		<a v-if="!getMobileMenu" class="bottomMenu" @click="mobileMenu()">Adatok módosítása</a>
	</div>
</template>

<script>
import CalcElements from './CalcElements.vue';
import ContractDetails from '@json/Sidebar/ContractDetails.json';
import PropertyDetails from '@json/Sidebar/PropertyDetails.json';
import PackageInformation from '@json/Sidebar/PackageInformation.json';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import isMobile from 'is-mobile';
import { lock, unlock } from 'tua-body-scroll-lock';

export default {
	async mounted() {
		if (this.getInsuranceEvents.extend.length === 0) {
			await this.fetchInsuranceEvents();
		}
	},
	data() {
		return {
			porpertyElemets: false,
			packageElemets: false,
			contractDetails: ContractDetails,
			propertyDetails: PropertyDetails,
		};
	},
	components: {
		CalcElements,
		PropertyDetails,
	},
	computed: {
		...mapGetters(['getInsuranceEvents', 'hasMovables', 'getOutbuildings', 'getLoading', 'getMobileMenu']),
		computedPackageInformations() {
			let elements = _.cloneDeep(PackageInformation);
			let extend = _.map(_.cloneDeep(this.getInsuranceEvents.extend), extendEvent => {
				extendEvent.type = 'event';
				extendEvent.isTemp = true;
				extendEvent.label = extendEvent.name;
				extendEvent.className = '';
				extendEvent.wrapperClass = 'col-w100-chbox chbox_style-wrapper';

				return extendEvent;
			});

			extend = _.keyBy(_.sortBy(extend, 'id'), 'id');

			elements.groupElements1.elements = extend;

			return elements;
		},
		computedPropertyDetails() {
			const clone = _.cloneDeep(PropertyDetails);
			let elements = clone.groupElements1.elements;

			if (this.getOutbuildings.length > 0) {
				let i = 2;
				this.getOutbuildings.forEach((outbuilding, index) => {
					_.assign(clone, { [`groupElements${i}`]: { elements: {} } });
					_.assign(clone[`groupElements${i}`].elements, {
						insurance_value: {
							label: `${index + 1}. Melléképület értéke`,
							type: 'text',
							className: '',
							wrapperClass: '',
							tooltip: false,
							sidebar: true,
							rules: 'required|number_space',
							inputGroup: 'outbuildings',
							inputmode: 'numeric',
							format: true,
							index: index,
							unit: 'Ft',
						},
					});

					if (this.hasMovables) {
						_.assign(clone[`groupElements${i}`].elements, {
							movable_value: {
								label: `${index + 1}. Melléképület ingóságai`,
								type: 'text',
								className: '',
								wrapperClass: '',
								tooltip: false,
								sidebar: true,
								rules: 'required|number_space',
								inputGroup: 'outbuildings',
								inputmode: 'numeric',
								format: true,
								index: index,
								unit: 'Ft',
							},
						});
					}

					i++;
				});
			}

			return clone;
		},
		isMobile() {
			return isMobile();
		},
	},
	methods: {
		...mapActions(['fetchInsuranceEvents', 'recalculate']),
		...mapMutations(['setTempEvents', 'setMobileMenu']),
		cancel() {
			this.packageElemets = false;
			this.porpertyElemets = false;
		},
		porpertyedit() {
			this.packageElemets = false;
			this.porpertyElemets = !this.porpertyElemets;
		},
		packageEdit() {
			this.porpertyElemets = false;
			this.packageElemets = true;
		},
		mobileMenu() {
			this.setMobileMenu(!this.getMobileMenu);

			if (this.$refs.menu !== undefined) {
				this.getMobileMenu ? lock(this.$refs.menu[0]) : unlock(this.$refs.menu[0]);
			}
		},
		async handleInsuranceEventsSave() {
			this.setTempEvents();
			this.cancel();
			if (this.isMobile) {
				this.mobileMenu();
			}
			await this.recalculate();
		},
		async handlePropertyDetailsSave() {
			this.cancel();
			if (this.isMobile) {
				this.mobileMenu();
			}
			await this.recalculate();
		},
	},
};
</script>
